import React from 'react';
import moment from 'moment';
import { NumberInput, DropdownSelector, TextInput, RadioButton, DatePicker } from './ui-react';

class AdvancedFilters extends React.Component {
  constructor(props) {
    super(props);
    this.handleSearch = this.handleSearch.bind(this);
    this.state = {
      advancedFilters: {},
    };
  }
  componentDidMount() {
    this.setState({ advancedFilters: this.props.advancedFilters });
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.state.advancedFilters) !== JSON.stringify(nextProps.advancedFilters)) {
      if (!nextProps.initialized) {
        this.setState({ advancedFilters: nextProps.advancedFilters });
      }
    }
  }
  render() {
    return (
      <div>
        {
          Object.keys(this.state.advancedFilters).map((filterName, i) => {
            const advancedFilter = { ...this.state.advancedFilters[filterName] };
            if (advancedFilter.hide) return null;
            advancedFilter.name = filterName;
            return (
              <div className="row" key={ i }>
                { this.renderFilter(advancedFilter) }
              </div>
            );
          })
        }
        <div className="input-group-btn">
          <button className="btn btn-primary btn-sm" onClick={ this.handleSearch }>Search</button>
        </div>
      </div>
    );
  }
  renderFilter(advancedFilter) {
    const label = advancedFilter.label || advancedFilter.name;
    const propsFilter = {
      label,
      value: advancedFilter.value,
      onChange: this.handleChange.bind(this, advancedFilter.name),
    };
    if (advancedFilter.type === 'relation') propsFilter.options = advancedFilter.options(this.props);
    switch (advancedFilter.type) {
    case 'number':
      return <NumberFilter { ...propsFilter } />;
    case 'date':
      return <DateFilter { ...propsFilter } />;
    case 'text':
      return <TextFilter { ...propsFilter } />;
    case 'boolean':
      return <BooleanFilter { ...propsFilter } />;
    case 'relation':
      return <RelationFilter { ...propsFilter } />;
    default:
      return null;
    }
  }
  handleChange(filterName, value) {
    const advancedFilter = { ...this.state.advancedFilters[filterName] };
    advancedFilter.value = value;
    this.setState({ advancedFilters: { ...this.state.advancedFilters, [filterName]: advancedFilter } });
  }
  handleSearch() {
    this.props.onSearch(this.state.advancedFilters);
  }
}

const NumberFilter = ({ label, value = {}, onChange }) => {
  const handleChange = (attributeName, field) => {
    const val = { ...value };
    val[attributeName] = field.value;
    onChange(val);
  };
  return (
    <div>
      <div className="col-md-1">
        <div className="form-group">
          <label className="col-sm-2">{ label }</label>
        </div>
      </div>
      <div className="col-md-2">
        <NumberInput
          horizontal={ true }
          label="Min"
          name="min"
          value={ value.min }
          onChange={ handleChange.bind(null, 'min') }
        />
      </div>
      <div className="col-md-2">
        <NumberInput
          horizontal={ true }
          label="Max"
          name="max"
          value={ value.max }
          onChange={ handleChange.bind(null, 'max') }
        />
      </div>
    </div>
  );
};
const DateFilter = ({ label, value = {}, onChange }) => {
  const handleChange = (attributeName, field, advancedFilters) => {
    const val = field.value ? moment(field.value).format('YYYY-MM-DD') : '';
    onChange({ ...value, [attributeName]: val });
  };
  return (
    <div>
      <div className="col-md-1">
        <div className="form-group">
          <label className="col-sm-2">{ label }</label>
        </div>
      </div>
      <div className="col-md-2">
        <DatePicker
          horizontal={ true }
          label="From"
          name="from"
          value={ value.from }
          onChange={ handleChange.bind(null, 'from') }
        />
      </div>
      <div className="col-md-2">
        <DatePicker
          horizontal={ true }
          label="To"
          name="to"
          value={ value.to }
          onChange={ handleChange.bind(null, 'to') }
        />
      </div>
    </div>
  );
};
const TextFilter = ({ label, value = {}, onChange }) => {
  const handleChange = (attributeName, field) => {
    const val = { ...value };
    val[attributeName] = field.value;
    onChange(val);
  };
  return (
    <div>
      <div className="col-md-1">
        <div className="form-group">
          <label className="col-sm-2">{ label }</label>
        </div>
      </div>
      <div className="col-md-2">
        <DropdownSelector
          horizontal={ true }
          label=""
          options={ [{ name: 'includes', value: 'match' }, { name: 'equals', value: 'eq' }] }
          value={ value.cond || 'match' }
          onChange={ handleChange.bind(null, 'cond') }
        />
      </div>
      <div className="col-md-2">
        <TextInput
          horizontal={ true }
          label="text"
          value={ value.text }
          onChange={ handleChange.bind(null, 'text') }
        />
      </div>
    </div>
  );
};
const BooleanFilter = ({ label, value = {}, onChange }) => {
  const handleChange = (isSet) => {
    const val = { ...value };
    if (isSet) {
      val.set = val.set === 'set' ? '' : 'set';
    } else {
      val.set = val.set === 'not_set' ? '' : 'not_set';
    }
    onChange(val);
  };
  return (
    <div>
      <div className="col-md-1">
        <div className="form-group">
          <label className="col-sm-2">{ label }</label>
        </div>
      </div>
      <div className="col-md-2">
        <RadioButton
          horizontal={ true }
          label="is set"
          checked={ value.set === 'set' }
          onChange={ handleChange.bind(null, true) }
        />
      </div>
      <div className="col-md-2">
        <RadioButton
          horizontal={ true }
          label="is not set"
          checked={ value.set === 'not_set' }
          onChange={ handleChange.bind(null, false) }
        />
      </div>
    </div>
  );
};
const RelationFilter = ({ label, value = '', options = [], onChange }) => {
  const handleChange = (field) => {
    onChange(field.value);
  };
  return (
    <div>
      <div className="col-md-1">
        <div className="form-group">
          <label className="col-sm-2">{ label }</label>
        </div>
      </div>
      <div className="col-md-4">
        <DropdownSelector
          label={ null }
          value={ value }
          options={ options }
          onChange={ handleChange }
        />
      </div>
    </div>
  );
};

export default AdvancedFilters;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/AdvancedFilters.jsx